import { AfterViewInit, ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { isNullOrUndefined } from '@sla-ng/core';
import * as moment from 'moment';
import { Observable } from 'rxjs';
import { ICostCenter } from '../../../../models/cost-center.model';
import { ICostCenterState } from '../../../../services/facades/master-data/cost-center-state.model';
import { CostCenterFacade } from '../../../../services/facades/master-data/cost-center.facade';

@Component({
    selector: 'app-cost-center-dialog',
    templateUrl: './cost-center-dialog.component.html',
    styleUrls: [ './cost-center-dialog.component.scss' ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CostCenterDialogComponent implements OnInit, AfterViewInit {
    public costCenterState$: Observable<ICostCenterState>;
    public formGroup: FormGroup;
    public dialogFieldsValid: boolean = false;

    constructor(
        private myMatDialogRef: MatDialogRef<CostCenterDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ICostCenter,
        private myCostCenterFacade: CostCenterFacade,
    ) {
    }

    public ngOnInit(): void {
        this.costCenterState$ = this.myCostCenterFacade.subState();
    }

    public ngAfterViewInit(): void {
        this.formGroup.valueChanges.subscribe((costCenter: ICostCenter) => {
            this.validateDialogFields(costCenter);
        });
    }

    public async save(): Promise<void> {
        const data = this.formGroup.value as ICostCenter;
        if (isNullOrUndefined(this.data.id)) {
            await this.myCostCenterFacade.addKostenstelle(data);
        } else {
            data.id = this.data.id;
            await this.myCostCenterFacade.editKostenstelle(data);
        }
        this.myMatDialogRef.close(true);

    }

    public close(): void {
        this.myMatDialogRef.close(false);
    }

    private validateDialogFields(costCenter: ICostCenter): void {
        // Validations to disable saving/editing
        if (!costCenter.name ||
            !costCenter.financialAccountingNr ||
            !costCenter.costCenterGroupId ||
            (!isNullOrUndefined(costCenter.validFrom) && !isNullOrUndefined(costCenter.validTo) &&
                moment.isMoment(costCenter.validFrom) && moment.isMoment(costCenter.validTo) &&
                costCenter.validTo.isBefore(costCenter.validFrom))) {
            this.dialogFieldsValid = false;
        } else {
            this.dialogFieldsValid = true;
        }
    }
}
